module.exports = " <div class=vux-timeline> <ul> <slot></slot> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/timeline/timeline.vue
// module id = 257
// module chunks = 2